import { apiClient } from "@/services/HttpService";

export function listCompany(params) {
  return apiClient.post("/project-company/search", params);
}

export function saveCompany(params) {
  return apiClient.post("/project-company", params);
}

export function loadCompany(companyId) {
  return apiClient.get(`/project-company/${companyId}`);
}

export function delCompany(companyId) {
  return apiClient.delete(`/project-company/${companyId}`);
}

export function loadMyCompanyList(){
  return apiClient.get("/project-company/mine");
}

export function loadCompanyTeamMembers(companyId, teamRole){
  return apiClient.get(`/company-team-member/${companyId}/${teamRole}`);
}

export function configTeamMembers(params){
  return apiClient.post("/company-team-member", params);
}